import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import {
  showContract,
  deletePayment,
  updateContract,
  resendEmail,
  updatePrintContract,
} from "../../../actions/contracts";
import { fetchMedicalRecords } from "../../../actions/medicalRecords";
import { getConfigByName } from "../../../actions/configuration";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../../components/loader";
import AddPaymentForm from "./addPayment";
import { fetchHwFindUs } from "../../../actions/howFindUs";
import PhoneInput from "react-phone-number-input";
import { BreadCrumb } from "../../../components/breadcrumb";
import { fetchConfig } from "../../../actions/configuration.js";

import { PDFExport } from "@progress/kendo-react-pdf";
import HeaderTemplate from "../../../components/contractPdf/header.js";
import ContractPDF from "../../../components/contractPdf/contractPdf.js";
import _ from 'lodash';
import "react-phone-number-input/style.css";

const $ = window.$;
let edit_form = {};
// const contractPdf = {};

const toCapitalize = (name) => {
  if (name && name.length > 1) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
}

class ContractsView extends Component {
  constructor(props) {
    super(props);
    this.contractPdf = React.createRef();
  }

  state = {
    contract: {
      ContractPayments: [],
      Customer: {},
      MedicalRecord: { Breed: {}, Pet: {}, Registration_type: {}, Breeder: {} }
    },
    editCustomer: false,
    loadingCustomer: false,
    editPayment: false,
    loadingPayment: false,
    loadingDelete: false,
    deleteContractId: null,
    hwTypes: [],
    hwFindUS: null,
    country: "",
    c_firstname: "",
    c_lastname: "",
    c_city: "",
    c_zip_code: "",
    c_phone_primary: "",
    c_phone_primary_type: "",
    c_hw_find_us: "",
    c_email: "",
    c_address: "",
    c_address_opt: "",
    c_phone_secondary: "",
    c_phone_secondary_type: "",
    c_state: "",

    // Pet Delivery Information
    c_delivery_address_full: "",
    c_delivery_address: "",
    c_delivery_address_opt: "",
    c_delivery_town_city: "",
    c_delivery_state: "",
    c_delivery_zip_code: "",

    sameAsBillingAddress: true,

    n_price: "",
    n_tax: "",
    n_total: "",
    n_sub_total: "",
    discount: "",
    new_tax_rate : "",
    paymentTypes: [],
    mrContentData: [],
    prevEle:null,
    nextEle:null,
    showMrFlag:null,
    pdfOldVersion: false,
    clickedId: '',
    loading: false,
  };

  openPdf = (id) => {    
    if(this.state.clickedId !== id) {    
      this.setState({clickedId: id});
    }
    else {    
      if(this.props.data.contractsReducer.printContract){
        this.childDownload();
    }
    }
  };

  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  };

  componentDidMount() {   
    this.props.showContract(this.props.match.params.id);
    this.props.fetchConfig();
    this.setState({ country: this.props.petShop.currentPetshop.country, loading: true });
    this.handleInputChange = this.handleInputChange.bind(this);
    this.props.fetchMedicalRecords();
    
  }

  componentWillReceiveProps = nextProps => {
    if (
      this.props.data.contractsReducer.showContract !==
      nextProps.data.contractsReducer.showContract
    ) {
      const petContract = nextProps.data.contractsReducer.showContract;   
      let hasDeliveryInformation = false;

      if (petContract && petContract.Customer && petContract.MedicalRecord && (petContract.Customer.delivery_address_full
        || petContract.Customer.delivery_address
        || petContract.Customer.delivery_address_opt
        || petContract.Customer.delivery_town_city
        || petContract.Customer.delivery_state
        || petContract.Customer.delivery_zip_code)) {
        hasDeliveryInformation = true;
      }

      this.setState({
        contract: nextProps.data.contractsReducer.showContract,
        sameAsBillingAddress: !hasDeliveryInformation,
        pdfOldVersion: petContract.configPdfVersion,
        loading : false,

      });
    }
    if (
      this.props.data.contractsReducer.showContractError !==
      nextProps.data.contractsReducer.showContractError
    ) {
      this.setState(this.state);
      NotificationManager.error("Something went wrong!");
    }

    if (
      this.props.data.contractsReducer.email !==
      nextProps.data.contractsReducer.email
    ) {
      // this.setState(this.state);
      NotificationManager.success(nextProps.data.contractsReducer.email.message);
    }

    if (
      this.props.data.contractsReducer.deletedPayment !==
      nextProps.data.contractsReducer.deletedPayment
    ) {
      this.setState({ loadingDelete: false });
      this.props.showContract(this.props.match.params.id);
      NotificationManager.success("Payment Deleted Successfully");
      $("#confirm_delete_modal").modal("hide");
    }
    if (
      this.props.data.contractsReducer.deletedPaymentError !==
      nextProps.data.contractsReducer.deletedPaymentError
    ) {
      this.setState({ loadingDelete: false });
      this.props.showContract(this.props.match.params.id);
      NotificationManager.error("Failed to delete payment.");
      $("#confirm_delete_modal").modal("hide");
    }

    if (
      this.props.data.contractsReducer.updatedContract !==
      nextProps.data.contractsReducer.updatedContract
    ) {
      this.setState({
        loadingCustomer: false,
        editCustomer: false,
        loadingPayment: false,
        editPayment: false
      });
      this.props.showContract(this.props.match.params.id);
      NotificationManager.success("Updated Successfully");
    }
    if (
      this.props.data.contractsReducer.updatedContractError !==
      nextProps.data.contractsReducer.updatedContractError
    ) {
      this.setState({
        loadingCustomer: false,
        editCustomer: false,
        loadingPayment: false,
        editPayment: false
      });
      this.props.showContract(this.props.match.params.id);
      NotificationManager.error("Failed to update.");
    }

    if (
      this.props.data.contractsReducer.newPayment !==
      nextProps.data.contractsReducer.newPayment
    ) {
      this.props.showContract(this.props.match.params.id);
    }
    if (
      this.props.hwTypes !== nextProps.hwTypes &&
      nextProps.hwTypes.length > 0
    ) {
      let options = [];
      nextProps.hwTypes.map(f => {
        options.push({ label: f.hw_find_us_type, value: f.hw_find_us_type });
      });
      this.setState({ hwTypes: options });
      this.setState({ hwFindUS: nextProps.hwTypes[0].hw_find_us_type });
    }
    if (this.props.configs !== nextProps.configs) {
      const taxRateObj = nextProps.configs.find(
        ({ name }) => name === "default_tax_rate"
      );
      this.setState({ new_tax_rate: taxRateObj.value});
    }
    if (nextProps.data.medicalRecordsReducer.mRecords &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords.length > 0 &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords !==
      this.props.data.medicalRecordsReducer.mRecords.medicalRecords
    ) {
      let records = nextProps.data.medicalRecordsReducer.mRecords.medicalRecords;     
      this.setState({mrContentData: records });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {

    if (prevState.discount !== this.state.discount) {
        let sub_total = parseFloat(this.state.contract.MedicalRecord.price) - parseFloat(this.state.discount);
        let new_tax = (sub_total * parseFloat(this.state.new_tax_rate)) / 100;
        let total = sub_total + new_tax;
        this.setState({ n_total: total , n_tax : new_tax, n_sub_total : sub_total });
    }

    if(prevState.mrContentData !== this.state.mrContentData){            
       this.setMrUrl();
    }

    if(prevState.contract !== this.state.contract){ 
        this.setMrUrl();   
    }

    if(this.state.clickedId && this.state.clickedId !== prevState.clickedId) {
      this.props.updatePrintContract(this.state.clickedId);
    }

    if(this.props.data.contractsReducer.printContract && prevProps.data.contractsReducer.printContract !== this.props.data.contractsReducer.printContract){
      this.childDownload();
    }

  };

  setMrUrl(){
    let data = this.state.mrContentData;
    let mrData = this.state.contract; 
    let mrId = this.state.contract.MedicalRecord.id;     
    if(mrId) {            
      let index = _.findIndex(data, {id: mrData.MedicalRecord.id});            
      let previndex = (index == 0) ? null : (index - 1);
      let nextindex = index + 1;
      let nextEle = nextindex != null ? data[nextindex] ? data[nextindex].id : mrId : mrId;
      let prevEle = previndex != null ? data[previndex] ? data[previndex].id : mrId : mrId; 
      this.setState({prevEle:prevEle, nextEle:nextEle,showMrFlag: true});  
    }
    else{ 
      this.setState({showMrFlag: false});    
     
    } 
  }  

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  editCustomer = () => {
    this.props.fetchHwFindUsTypes();
    if (!this.state.editCustomer) {
      this.setState({
        editCustomer: true,
        c_firstname: this.state.contract.Customer.firstname || "",
        c_lastname: this.state.contract.Customer.lastname || "",
        c_city: this.state.contract.Customer.city || "",
        c_zip_code: this.state.contract.Customer.zip_code || "",
        c_phone_primary: this.state.contract.Customer.phone_primary || "",
        c_phone_primary_type:
          this.state.contract.Customer.phone_primary_type || "",
        c_phone_secondary: this.state.contract.Customer.phone_secondary || "",
        c_phone_secondary_type:
          this.state.contract.Customer.phone_secondary_type || "mobile",
        c_hw_find_us: this.state.contract.Customer.find_us || "",
        c_email: this.state.contract.Customer.email || "",
        c_address: this.state.contract.Customer.address || "",
        c_address_opt: this.state.contract.Customer.address_opt || "",
        c_phone_home: this.state.contract.Customer.phone_home || "",
        c_state: this.state.contract.Customer.state || "",
        c_delivery_address_full: this.state.contract.Customer.delivery_address_full || "",
        c_delivery_address: this.state.contract.Customer.delivery_address || "",
        c_delivery_address_opt: this.state.contract.Customer.delivery_address_opt || "",
        c_delivery_town_city: this.state.contract.Customer.delivery_town_city || "",
        c_delivery_state: this.state.contract.Customer.delivery_state || "",
        c_delivery_zip_code: this.state.contract.Customer.delivery_zip_code || ""
      });
    } else {
      this.cancelEditCustomer();
    }
  };

  editPayment = () => {
    if (!this.state.editPayment) {
      this.setState({
        editPayment: true,
        n_price: this.state.contract.price || "",
        discount : this.state.contract.discount || "",
        n_tax : this.state.contract.tax,
        n_total : this.state.contract.total,
        n_sub_total : this.state.contract.sub_total,
      });
    } else {
      this.cancelEditPayment();
    }
  };

  changeVal = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  changeHwType = selected => {
    this.setState({ c_hw_find_us: selected.value });
  };
  cancelEditCustomer = () => {
    let hasDeliveryInformation = false;

    if (this.state.contract && this.state.contract.Customer && (this.state.contract.Customer.delivery_address_full
      || this.state.contract.Customer.delivery_address
      || this.state.contract.Customer.delivery_address_opt
      || this.state.contract.Customer.delivery_town_city
      || this.state.contract.Customer.delivery_state
      || this.state.contract.Customer.delivery_zip_code)) {
      hasDeliveryInformation = true;
    }

    this.setState({ editCustomer: false, sameAsBillingAddress: !hasDeliveryInformation });
  };

  cancelEditPayment = () => {
    this.setState({ editPayment: false });
  };

  openConfirmModal = cpId => {
    this.setState({ deleteContractId: cpId });
    $("#confirm_delete_modal").modal("show");
  };
  getPaymentMethod = typeId => {
    // debugger;
    return this.state.paymentTypes.find(({ id }) => id === typeId);
  };
  handleChildUnmount(){
    this.setState({clickedId: false});
  }
  resendEmail = () => {
    if (this.state.contract && this.state.contract.MedicalRecord && this.state.contract.MedicalRecord.BreedCategory) {
      let emailbody = {
        arrivalDate: this.state.contract.MedicalRecord.arrival_date,
        avatarFilename: this.state.contract.MedicalRecord.avatar_file_name,
        avatarPath: this.state.contract.MedicalRecord.avatar_path,
        emailTemplateName: this.state.contract.MedicalRecord.BreedCategory.email_templatename,
        customerName: this.state.contract.Customer.firstname,
        contractDate: this.state.contract.date,
        email: this.state.contract.cus_email,
        medicalRecordId : this.state.contract.MedicalRecord.id,
        zipCode : this.state.contract.Customer.zip_code,
        foodType : this.state.contract.MedicalRecord.FoodType ? this.state.contract.MedicalRecord.FoodType :  null,  
      }
      this.props.resendEmail(emailbody);
    }
    else {
      NotificationManager.warning("Welcome Email template not set");
    }
  };
  deletePayment() {
    this.setState({ loadingDelete: true });
    let data = { id: this.state.deleteContractId };
    if (data) this.props.deletePayment(data);
    else {
      NotificationManager.warning("Payment data can not be found.");
      this.setState({ loadingDelete: false });
    }
  }
  validateForm = edit_form => {
    let formdata = Object.values(edit_form).map(key => {
      if (key === null) {
        return false;
      } else {
        return true;
      }
    });
    if (!formdata.includes(false)) {
      this.props.updateContract(this.state.contract.id, edit_form);
    } else {
      NotificationManager.warning("Please check input details again.");
      this.setState({ currentFormNotValid: true, loadingCustomer: false });
    }
  };
  saveCustomer = () => {
    const regX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    edit_form = {
      c_firstname:
        this.state.c_firstname.trim().length > 0
          ? this.state.c_firstname
          : null,
      c_lastname:
        this.state.c_lastname.trim().length > 0 ? this.state.c_lastname : null,
      c_city: this.state.c_city.trim().length > 0 ? this.state.c_city : null,
      c_zip_code:
        this.state.c_zip_code.toString().trim().length > 0
          ? this.state.c_zip_code
          : null,
      c_phone_primary: this.state.c_phone_primary
        ? this.state.c_phone_primary
        : null,
      c_phone_primary_type:
        this.state.c_phone_primary_type.trim().length > 0
          ? this.state.c_phone_primary_type
          : null,
      c_phone_secondary: this.state.c_phone_secondary
        ? this.state.c_phone_secondary
        : '',
      c_phone_secondary_type: this.state.c_phone_secondary_type &&
        this.state.c_phone_secondary_type.trim().length > 0
          ? this.state.c_phone_secondary_type
          : '',
      c_find_us:
        this.state.c_hw_find_us.trim().length > 0
          ? this.state.c_hw_find_us
          : null,
      c_email: String(this.state.c_email)
        .toLowerCase()
        .match(regX)
        ? this.state.c_email
        : null,
      c_address:
        this.state.c_address.trim().length > 0 ? this.state.c_address : null,
      c_address_opt:
        this.state.c_address_opt.trim().length > 0
          ? this.state.c_address_opt
          : "N/A",
      c_state: this.state.c_state.trim().length > 0 ? this.state.c_state : null,

      c_delivery_address_full: this.state.c_delivery_address_full.trim().length > 0 && !this.state.sameAsBillingAddress ? this.state.c_delivery_address_full : "",
      c_delivery_address:
        this.state.c_delivery_address.trim().length > 0 && !this.state.sameAsBillingAddress ? this.state.c_delivery_address : "",
      c_delivery_address_opt:
        this.state.c_delivery_address_opt.trim().length > 0 && !this.state.sameAsBillingAddress
          ? this.state.c_delivery_address_opt
          : "",
      c_delivery_town_city: this.state.c_delivery_town_city.trim().length > 0 && !this.state.sameAsBillingAddress ? this.state.c_delivery_town_city : "",
      c_delivery_state: this.state.c_delivery_state.trim().length > 0 && !this.state.sameAsBillingAddress ? this.state.c_delivery_state : "",
      c_delivery_zip_code:
        this.state.c_delivery_zip_code.toString().trim().length > 0 && !this.state.sameAsBillingAddress
          ? this.state.c_delivery_zip_code
          : "",
    };
    this.setState({ loadingCustomer: true });
    this.validateForm(edit_form);
  };
  savePayment = () => {
    this.setState({ loadingCustomer: true });
    let data = {
      n_tax: this.state.n_tax,
      discount : this.state.discount,
      n_total : this.state.n_total,    
    };

    if (parseFloat(data.n_total) >= 0 && parseFloat(data.n_tax) >= 0) {
      this.props.updateContract(this.state.contract.id, data);
    } else {
      NotificationManager.warning("Customer info not completed.");
      this.setState({ loadingCustomer: false });
    }
  };

  items = [
    { title: "Contracts", to: "/contracts" },
    { title: "Edit", to: "/contracts/" + this.props.match.params.id }
  ];

  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  }

  render() {
    const {
      country,
      contract,
      editCustomer,
      c_firstname,
      c_lastname,
      c_city,
      c_zip_code,
      c_phone_primary,
      c_phone_primary_type,
      c_hw_find_us,
      hwTypes,
      c_email,
      c_address,
      c_address_opt,
      c_phone_secondary,
      c_phone_secondary_type,
      c_state,

      c_delivery_address_full,
      c_delivery_address,
      c_delivery_address_opt,
      c_delivery_town_city,
      c_delivery_state,
      c_delivery_zip_code,

      sameAsBillingAddress,

      n_price,
      n_tax,
      n_total,
      n_sub_total,
      discount,
      editPayment,
      prevEle,
      nextEle,
      showMrFlag,
      loading,

    } = this.state;

    return (
      <div
        className="m-grid m-grid--hor m-grid--root m-page"
        style={{ minHeight: "100vh" }}
      >
       {!loading ? 
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="row">
                <div className="col-lg-12">
                  <BreadCrumb items={this.items} />
                </div>
                {/* <div className="col-lg-4">
                                    <button type="button" className="btn m-btn--pill btn-warning pull-right" style={{marginRight:'25px'}} onClick={() => this.childDownload()}><span style={{fontWeight:400,fontSize:'13px'}}><i className="far fa-file-pdf"></i> Download PDF</span> </button>
                                    
                                </div> */}
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-8 col-lg-7">
                  <div className="m-portlet m-portlet--full-height ">
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{ boxShadow: "none" }}
                    >
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">
                              Pet Information
                            </h3>
                          </div>
                        </div>
                        <div className="m-portlet__head-tools">  
                        {  this.state.pdfOldVersion == true ?
                        <span className="dropdown show">
                          <span className="dropdown">
                            <a
                              href=""                      
                              data-toggle="dropdown"
                              aria-expanded="true"
                            >
                            <button                           
                            className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air mr-2"
                          >
                            <i className="la la-print"></i>
                            <span>PDF</span>
                          </button>                            
                            </a>
                            <div className="dropdown-menu dropdown-menu-right">   
                              <a 
                                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/contract/pdf/${this.props.data.petShopReducer.currentPetshop.id}/${contract.id}`}              
                                className="dropdown-item"
                                target="_blank"        
                              >
                                <i className="fa fa-print"></i>PDF
                              </a>                                          
                             <a
                                className="dropdown-item"
                                href="#"
                                onClick={() => {
                                  this.openPdf(contract.id)
                                }}
                              >
                                <i class="fa fa-print"></i>PDF (Old)
                              </a>
                            
                            </div>
                          </span>
                          </span>:
                            <button                           
                              className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air mr-2"
                             >
                                <a
                                 href={ `${process.env.REACT_APP_API_ENDPOINT}/core/contract/pdf/${this.props.data.petShopReducer.currentPetshop.id}/${contract.id}`}    
                                 target="_blank"  
                                 style={{color:"#282a3c",textDecoration:"none"}}
                                >
                                <i className="la la-print"></i>
                                <span>PDF</span>
                                </a>
                            </button>   

                        }                    
                      </div>
                      </div>
                     
                      <div className="m-portlet__body">
                        <div className="m-widget4">
                          <div className="row align-items-center mt-4">
                            <div className="col-lg-4 col-sm-12">
                              <div className="row">
                                <div className="m-widget4__img m-widget4__img--pic  mx-auto my-2 user-avatar">
                                  <img
                                    src={
                                      process.env.REACT_APP_S3_PATH +
                                      "/" +
                                      contract.MedicalRecord.avatar_path +
                                      "/" +
                                      contract.MedicalRecord.avatar_file_name
                                    }
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="m-widget4__info  mx-auto">
                                  <span className="m-widget4__title">
                                    {contract.MedicalRecord.Breed.breed_type}
                                  </span>
                                </div>
                              </div>
                              <div className="row">
                                <span className="m-badge m-badge--info mx-auto my-0 px-2">
                                  <strong>Id: </strong>
                                  {contract.MedicalRecord.pet_id}
                                </span>
                              </div>
                              <div className="row">
                                { showMrFlag && (
                                <NavLink
                                  to={`/medical-records/${contract.MedicalRecord.id}/${prevEle}/${nextEle}`}
                                  className="m-link m-link--info m--font-bold mx-auto mt-2"
                                >
                                  View Medical Record
                                </NavLink>
                                 )}
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-12">
                            <div className="m-widget4__item">
                              <span className="m-widget4__sub">
                                  <i className="fas fa-calendar-alt mr-2"></i>
                                  <span>
                                    <strong>Contract Date: </strong>
                                  </span>
                                  {contract.date}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-birthday-cake mr-2"></i>
                                  <span>
                                    <strong>Birthday: </strong>
                                  </span>
                                  {contract.MedicalRecord.date_of_birth}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-microchip mr-2"></i>
                                  <span>
                                    <strong>Microchip: </strong>
                                  </span>
                                  {contract.MedicalRecord.micro_chip}
                                </span>
                              </div>
                             
                              
                            </div>
                            <div className="col-lg-4 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-genderless mr-2"></i>
                                  <span>
                                    <strong>Gender: </strong>
                                  </span>
                                  {contract.MedicalRecord.sex}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-paint-brush mr-2"></i>
                                  <span>
                                    <strong>Color: </strong>
                                  </span>
                                  {contract.MedicalRecord.color_markings}
                                </span>
                              </div>
                              <div className="m-widget4__item mt-4">

                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{ boxShadow: "none" }}
                    >
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">
                              Customer Information
                            </h3>
                          </div>
                        </div>
                        <div className="m-portlet__head-tools">
                          <button
                            onClick={() => this.editCustomer()}
                            className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air"
                          >
                            <i className="la la-edit"></i>
                            <span>Edit</span>
                          </button>                        
                        </div>
                      </div>

                      <div className="m-portlet__body">
                        <div className="m-widget4">
                          <div className="row mt-4">
                            <div className="col-md-6">
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-user mr-2"></i>
                                  <span>
                                    <strong>First Name: </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="c_firstname"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={c_firstname}
                                      />
                                      <span
                                        className={
                                          edit_form.c_firstname === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter customer name
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      contract.Customer.firstname
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-user mr-2"></i>
                                  <span>
                                    <strong>Last Name: </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="c_lastname"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={c_lastname}
                                      />
                                      <span
                                        className={
                                          edit_form.c_lastname === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter customer name
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      contract.Customer.lastname
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-marker-alt mr-2"></i>
                                  <span>
                                    <strong>Street Addresss: </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="c_address"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={c_address}
                                      />
                                      <span
                                        className={
                                          edit_form.c_address === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Select street address
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      contract.Customer.address
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-marker-alt mr-2"></i>
                                  <span>
                                    <strong>Apt/Suit/Building: </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="c_address_opt"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={c_address_opt}
                                      />
                                      <span className="m-form__help">
                                        Enter additional address
                                        details(Optional)
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      contract.Customer.address_opt
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-signs mr-2"></i>
                                  <span>
                                    <strong>City: </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="c_city"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={c_city}
                                      />
                                      <span
                                        className={
                                          edit_form.c_city === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter customer city
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      contract.Customer.city
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-signs mr-2"></i>
                                  <span>
                                    <strong>State: </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="c_state"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={c_state}
                                      />
                                      <span
                                        className={
                                          edit_form.c_state === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter state
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      contract.Customer.state
                                    )}
                                </span>
                              </div>                             
                            </div>

                            <div className="col-md-6">
                            <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-map-pin mr-2"></i>
                                  <span>
                                    <strong>Zip Code: </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="c_zip_code"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={c_zip_code}
                                      />
                                      <span
                                        className={
                                          edit_form.c_zip_code === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter zip code
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      contract.Customer.zip_code
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-phone mr-2"></i>
                                  <span>
                                    <strong>
                                      Primary Phone (
                                      {editCustomer
                                        ? c_phone_primary_type
                                        : contract.Customer.phone_primary_type}
                                      ):{" "}
                                    </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <div className="input-group mb-1">
                                        <div className="input-group-prepend">
                                          <select
                                            type="text"
                                            name="c_phone_primary_type"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                            placeholder=""
                                            value={c_phone_primary_type}
                                          >
                                            <option>mobile</option>
                                            <option>work</option>
                                            <option>home</option>
                                          </select>
                                        </div>
                                        <PhoneInput
                                          country={country}
                                          className="form-control"
                                          placeholder="Enter primary number"
                                          value={c_phone_primary}
                                          onChange={value =>
                                            this.setState({
                                              c_phone_primary: value
                                            })
                                          }
                                        />
                                      </div>
                                      <span
                                        className={
                                          edit_form.c_phone_primary === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter primary phone
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      <a href={`tel:${contract.Customer.phone_primary}`} className="hyperlink-phone-number">
                                        {contract.Customer.phone_primary}
                                      </a>
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-phone mr-2"></i>
                                  <span>
                                    <strong>
                                      Secondary Phone (
                                      {editCustomer
                                        ? c_phone_secondary_type
                                        : contract.Customer
                                          .phone_secondary_type}
                                      ):{" "}
                                    </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <div className="input-group mb-1">
                                        <div className="input-group-prepend">
                                          <select
                                            type="text"
                                            name="c_phone_secondary_type"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                            placeholder=""
                                            value={c_phone_secondary_type}
                                          >
                                            <option>mobile</option>
                                            <option>work</option>
                                            <option>home</option>
                                          </select>
                                        </div>
                                        <PhoneInput
                                          country={country}
                                          className="form-control"
                                          placeholder="Enter Secondary number"
                                          value={c_phone_secondary}
                                          onChange={value =>
                                            this.setState({
                                              c_phone_secondary: value
                                            })
                                          }
                                        />
                                      </div>
                                      <span
                                        className={
                                          edit_form.c_phone_secondary ===
                                            null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Add secondary phone
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      <a href={`tel:${contract.Customer.phone_secondary}`} className="hyperlink-phone-number">
                                        {contract.Customer.phone_secondary}
                                      </a>
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-envelope mr-2"></i>
                                  <span>
                                    <strong>Email: </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        name="c_email"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={c_email}
                                      />
                                      <span
                                        className={
                                          edit_form.c_email === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter valid email address
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      <a href={`mailto:${contract.Customer.email}?body=Hello, ${toCapitalize(contract.Customer.firstname)}!`}
                                        className="hyperlink">
                                          {contract.Customer.email}
                                      </a>
                                    )}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-search mr-2"></i>
                                  <span>
                                    <strong>How did you find us: </strong>
                                  </span>
                                  {editCustomer ? (
                                    <div className="m-form">
                                      <Select
                                        options={hwTypes}
                                        value={c_hw_find_us}
                                        name="c_hw_find_us"
                                        onChange={this.changeHwType}
                                        placeholder="Select how you find us?"
                                      />
                                      <span
                                        className={
                                          edit_form.c_hw_find_us === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Select how you find us
                                      </span>
                                    </div>
                                  ) : (
                                      contract.Customer !== null &&
                                      contract.Customer.find_us
                                    )}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">

                              <div className="m-portlet__body-separator mt-0"></div>

                            <div className="mr-auto">
                                <h5 className="m-subheader__title m--font-brand">Delivery Information</h5>
                            </div>

                              <div className="m-portlet__body-separator mb-0"></div>

                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <label>
                                    <input name="sameAsBillingAddress" type="checkbox" checked={sameAsBillingAddress} disabled={!editCustomer} onChange={this.handleInputChange} />
                                    <span className="ml-1">Same As Billing Address</span>
                                  </label>
                                </span>
                              </div>

                              {(!sameAsBillingAddress && contract.Customer.delivery_address_full) ?

                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-map-marker-alt mr-2"></i>
                                    <span>
                                      <strong>Street Address (Full): </strong>
                                    </span>
                                    {editCustomer ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="c_delivery_address_full"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={c_delivery_address_full}
                                        />
                                      </div>
                                    ) : (
                                        contract.Customer !== null &&
                                        contract.Customer.delivery_address_full
                                      )}
                                  </span>
                                </div>

                                : ""}

                            </div>
                          </div>

                          {!sameAsBillingAddress ?

                            <div className="row">
                              <div className="col-md-6">

                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-map-marker-alt mr-2"></i>
                                    <span>
                                      <strong>Street Address: </strong>
                                    </span>
                                    {editCustomer ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="c_delivery_address"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={c_delivery_address}
                                        />
                                      </div>
                                    ) : (
                                        contract.Customer !== null &&
                                        contract.Customer.delivery_address
                                      )}
                                  </span>
                                </div>

                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-map-marker-alt mr-2"></i>
                                    <span>
                                      <strong>Apartment, Suite, Unit, Etc.: </strong>
                                    </span>
                                    {editCustomer ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="c_delivery_address_opt"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={c_delivery_address_opt}
                                        />
                                        <span className="m-form__help">
                                          Enter additional address
                                          details(Optional)
                                      </span>
                                      </div>
                                    ) : (
                                        contract.Customer !== null &&
                                        contract.Customer.delivery_address_opt
                                      )}
                                  </span>
                                </div>

                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-map-signs mr-2"></i>
                                    <span>
                                      <strong>Town / City: </strong>
                                    </span>
                                    {editCustomer ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="c_delivery_town_city"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={c_delivery_town_city}
                                        />
                                      </div>
                                    ) : (
                                        contract.Customer !== null &&
                                        contract.Customer.delivery_town_city
                                      )}
                                  </span>
                                </div>

                              </div>
                              <div className="col-md-6">

                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-map-signs mr-2"></i>
                                    <span>
                                      <strong>State: </strong>
                                    </span>
                                    {editCustomer ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="c_delivery_state"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={c_delivery_state}
                                        />
                                      </div>
                                    ) : (
                                        contract.Customer !== null &&
                                        contract.Customer.delivery_state
                                      )}
                                  </span>
                                </div>

                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-map-pin mr-2"></i>
                                    <span>
                                      <strong>Zip Code: </strong>
                                    </span>
                                    {editCustomer ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="c_delivery_zip_code"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={c_delivery_zip_code}
                                        />
                                      </div>
                                    ) : (
                                        contract.Customer !== null &&
                                        contract.Customer.delivery_zip_code
                                      )}
                                  </span>
                                </div>

                              </div>
                            </div>

                            : ""}

                          <div className="row">
                            <div className="col-md-12">
                              {!editCustomer && (
                                <div className="m-widget4__action m--align-right">
                                  <button
                                    onClick={() => this.resendEmail()}
                                    type="button"
                                    className="btn m-btn--pill btn-outline-primary"
                                  >
                                    Resend Welcome Email
                                  </button>
                                </div>
                              )}                        
                            </div>
                            <div className="col-md-12">
                              {editCustomer && !this.state.loadingCustomer && (
                                <div className="m-widget4__action m--align-right">
                                  <button
                                    onClick={() => this.cancelEditCustomer()}
                                    type="button"
                                    className="btn m-btn--pill btn-secondary mr-2"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={() => this.saveCustomer()}
                                    type="button"
                                    className="btn m-btn--pill btn-outline-primary"
                                  >
                                    Save
                                  </button>
                                </div>
                              )}
                              {editCustomer && this.state.loadingCustomer && (
                                <div className="center-row">
                                  <Loader size={50} />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>             
                    </div>

                  </div>
                </div>
                <div className="col-xs-12 col-sm-8 col-md-8 col-lg-5">
                  <div className="m-portlet m-portlet--success m-portlet--head-solid-bg m-portlet--full-height ">
                    <div className="m-portlet__head">
                      <div className="m-portlet__head-caption">
                        <div className="m-portlet__head-title">
                          <h3 className="m-portlet__head-text">
                            Payment Information
                          </h3>
                        </div>
                      </div>
                      <div className="m-portlet__head-tools">
                        <ul className="m-portlet__nav">
                          <li className="m-portlet__nav-item">
                            <button
                              onClick={() => this.editPayment()}
                              className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air"
                            >
                              <i className="la la-edit"></i>
                              <span>Edit</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="m-portlet__body">
                      <div className="m-widget4">                  
                          <div className="row">
                          <div className="m-form form-group m-form__group col-md-3">
                            <span className="m-widget4__sub">
                              <span>
                                <strong>Price: </strong>
                              </span>
                            </span>
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <span className="input-group-text">$</span>                          
                                    <span className="input-group-text">
                                      {contract.MedicalRecord.price}
                                    </span>
                              </div>
                              
                            </div>
                          </div>
                          <div
                            className="col-md-1"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            -
                          </div>
                           <div className="m-form form-group m-form__group col-md-3">
                            <span className="m-widget4__sub">
                              <span>
                                <strong>Discount: </strong>
                              </span>
                            </span>
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <span className="input-group-text">$</span>
                                {editPayment ? (
                                  <input
                                    style={{width : "80px"}}
                                    name="discount"
                                    value={discount}
                                    onChange={this.changeVal}
                                    className="form-control m-input"
                                    placeholder=""
                                    aria-describedby="basic-addon1"
                                  />
                                ) : (
                                    <span className="input-group-text">
                                      {contract.discount}
                                    </span>
                                  )}
                              </div>
                              
                            </div>
                          </div>
                          <div
                            className="col-md-1"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            =
                          </div>
                          <div className="m-form  form-group m-form__group col-md-3">
                            <span className="m-widget4__sub">
                              <span>
                                <strong>Subtotal: </strong>
                              </span>
                            </span>
                            <div className="input-group">
                              <div className="input-group-append">
                                <span className="input-group-text">$</span>
                                {editPayment ? (
                                  <span className="input-group-text">
                                    {parseFloat(n_sub_total).toFixed(2)}                                   
                                  </span>
                                ) : (
                                    <span className="input-group-text">
                                      {contract.sub_total}
                                    </span>
                                  )}
                              </div>
                            </div>
                          </div>
                          </div>
                          <div className="row">
                          <div className="m-form form-group m-form__group col-md-7">                  
                          </div>                      
                          <div
                            className="col-md-1"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            +
                          </div>
                          <div className="m-form  form-group m-form__group col-md-4">
                            <span className="m-widget4__sub">
                              <span>
                                <strong>Tax: </strong>
                              </span>
                            </span>
                            <div className="input-group">
                              <div className="input-group-append">
                                <span className="input-group-text">$</span>
                                {editPayment ? (
                                  <span className="input-group-text">
                                    {parseFloat(n_tax).toFixed(2)}                                   
                                  </span>
                                ) : (
                                    <span className="input-group-text">
                                      {contract.tax}
                                    </span>
                                  )}
                              </div>
                            </div>               
                          </div>
                          </div>
                          <div className="row">
                          <div className="m-form  form-group m-form__group col-md-7">
                          </div>
                          <div
                            className="col-md-1"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            =
                          </div>
                          <div className="m-form  form-group m-form__group col-md-4">
                            <span className="m-widget4__sub">
                              <span>
                                <strong>Total: </strong>
                              </span>
                            </span>
                            <div className="input-group m-input-group m-input-group--solid">
                              <div className="input-group-append">
                                <span className="input-group-text">$</span>
                                <span className="input-group-text">
                                  {editPayment ? parseFloat(n_total).toFixed(2) : contract.total}
                                </span>
                              </div>
                             
                            </div>
                          </div>
                         </div>           
                   
                        {editPayment && !this.state.loadingPayment && (
                          <div className="m-widget4__action m--align-right">
                            <button
                              onClick={() => this.cancelEditPayment()}
                              type="button"
                              className="btn m-btn--pill btn-secondary mr-2"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={() => this.savePayment()}
                              type="button"
                              className="btn m-btn--pill btn-outline-primary"
                            >
                              Save
                            </button>
                          </div>
                        )}
                        {editPayment && this.state.loadingPayment && (
                          <div className="center-row">
                            <Loader size={50} />
                          </div>
                        )}
                        <div className="m-widget4__item mt-5">
                          <div
                            className="m-accordion m-accordion--default"
                            id="m_accordion_4"
                            role="tablist"
                          >
                            {contract.ContractPayments.map((p, i) => (
                              <div className="m-accordion__item" key={i}>
                                <div
                                  className="m-accordion__item-head collapsed"
                                  role="tab"
                                  id={"m_accordion_4_item_" + i + "_head"}
                                  data-toggle="collapse"
                                  href={"#m_accordion_4_item_" + i + "_body"}
                                  aria-expanded="false"
                                >
                                  <span className="m-accordion__item-icon">
                                    <i className="la la-money"></i>
                                  </span>
                                  <span className="m-accordion__item-title">
                                    Payment {i + 1} -{" "}
                                    {p.method === "credit_debit"
                                      ? "Credit/Debit"
                                      : p.PaymentType ? p.PaymentType.payment_type : ''}
                                  </span>
                                  <span className="m-accordion__item-mode"></span>
                                </div>
                                <div
                                  className="m-accordion__item-body collapse"
                                  id={"m_accordion_4_item_" + i + "_body"}
                                  role="tabpanel"
                                  aria-labelledby={
                                    "m_accordion_4_item_" + i + "_head"
                                  }
                                  data-parent="#m_accordion_4"
                                >
                                  <div className="m-accordion__item-content">
                                    <div className="m-widget4__item">
                                      <span className="m-widget4__sub">
                                        <i className="fas fa-dollar-sign mr-2"></i>
                                        <span>
                                          <strong>Amount: </strong>
                                        </span>
                                        {p.amount}
                                      </span>
                                    </div>
                                    {p.method === "credit_debit" && (
                                      <div>
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-credit-card mr-2"></i>
                                            <span>
                                              <strong>Card Type: </strong>
                                            </span>
                                            {p.card_type}
                                          </span>
                                        </div>
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-sort-numeric-down mr-2"></i>
                                            <span>
                                              <strong>Last Digits: </strong>
                                            </span>
                                            {p.last_digits}
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    <div className="m-widget4__item m--align-right">
                                      <span className="m-widget4__sub">
                                        <a
                                          href="#"
                                          onClick={() =>
                                            this.openConfirmModal(p.id)
                                          }
                                          className="btn m-btn--pill btn-outline-danger btn-sm mx-2"
                                        >
                                          <span>
                                            <i className="la la-minus-circle mr-2"></i>
                                            <span>Delete</span>
                                          </span>
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="mt-2" style={{ float: "right" }}>
                            <a
                              href="#"
                              className="btn btn-outline-primary m-btn m-btn--icon m-btn--pill"
                              data-toggle="modal"
                              data-target="#add_payment"
                            >
                              <span>
                                <i className="la la-plus"></i>
                                <span>New Payment</span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <button onClick={() => this.childDownload()}>download</button> */}
          {/* <ContractPDF setClick={this.acceptMethods.bind(this)} /> */}
        </div>:                    
        <div className={"loader-center"}>
          <Loader
            type="line-scale"
            active={true}
            className="loader-center"
          />
        </div>
        }

        <div
          className="modal fade"
          id="confirm_delete_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to delete
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this payment?</p>
              </div>
              <div className="modal-footer">
                {this.state.loadingDelete == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.deletePayment()}
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <AddPaymentForm cId={contract.id} />
        {this.state.clickedId ? <ContractPDF setClick={this.acceptMethods.bind(this)} unmountMe={this.handleChildUnmount.bind(this)} /> : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  petShop: state.petShopReducer,
  user: state.cognito.user,
  data: state,
  hwTypes: state.howFindUsReducer.hwTypes,
  configs: state.configReducer.configs
});

const mapDispatchToProps = dispatch => ({
  showContract: id => {
    dispatch(showContract(id));
  },
  updateContract: (id, data) => {
    dispatch(updateContract(id, data));
  },
  deletePayment: id => {
    dispatch(deletePayment(id));
  },
  fetchHwFindUsTypes: () => {
    dispatch(fetchHwFindUs());
  },
  fetchConfig: () => {
    dispatch(fetchConfig());
  },
  resendEmail: attrs => {
    dispatch(resendEmail(attrs));
  },
  fetchMedicalRecords: () => {
    dispatch(fetchMedicalRecords());
  },
  getConfigByName: (data) => {
    dispatch(getConfigByName(data));
  },
  updatePrintContract: (id) => {
    dispatch(updatePrintContract(id));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContractsView)
);
